import { SkeletonText } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useParams } from 'react-router'

import { useAccount } from '@features/accounts/hooks/useAccount'

import { ChartOfAccountsUrlParams } from '../../types/chartOfAccountsUrlParams'

export const AccountTitle = (): ReactElement => {
  const { accountId } = useParams<ChartOfAccountsUrlParams>()
  const { account, isLoading } = useAccount(accountId)

  if (isLoading) {
    return <SkeletonText variant="h1" width={200} />
  }

  return <>{`${account?.accountNo ? `${account?.accountNo} - ` : ''}${account?.name || ''}`}</>
}
